import React from 'react';

interface AscendantResultProps {
    title: string;
    image: string;
}

const ascendantDescriptions: { [key: string]: string } = {
    'Aries': 'Widder-Aszendent: Du wirkst dynamisch, mutig und durchsetzungsfähig. Du gehst Herausforderungen direkt an und zeigst Initiative.',
    'Taurus': 'Stier-Aszendent: Du wirkst ruhig, zuverlässig und bodenständig. Du schätzt Stabilität und Genuss im Leben.',
    'Gemini': 'Zwillinge-Aszendent: Du wirkst kommunikativ, neugierig und vielseitig. Du liebst den Austausch und neue Informationen.',
    'Cancer': 'Krebs-Aszendent: Du wirkst einfühlsam, fürsorglich und emotional. Du schützt gerne andere und schätzt Geborgenheit.',
    'Leo': 'Löwe-Aszendent: Du wirkst selbstbewusst, großzügig und charismatisch. Du liebst es, im Mittelpunkt zu stehen.',
    'Virgo': 'Jungfrau-Aszendent: Du wirkst präzise, analytisch und hilfsbereit. Du strebst nach Perfektion und Ordnung.',
    'Libra': 'Waage-Aszendent: Du wirkst harmoniebedürftig, diplomatisch und ästhetisch. Du suchst Ausgleich und Schönheit.',
    'Scorpio': 'Skorpion-Aszendent: Du wirkst intensiv, geheimnisvoll und leidenschaftlich. Du gehst Dingen auf den Grund.',
    'Sagittarius': 'Schütze-Aszendent: Du wirkst optimistisch, freiheitsliebend und philosophisch. Du liebst Abenteuer und Reisen.',
    'Capricorn': 'Steinbock-Aszendent: Du wirkst ambitioniert, diszipliniert und verantwortungsbewusst. Du strebst nach Erfolg und Anerkennung.',
    'Aquarius': 'Wassermann-Aszendent: Du wirkst unabhängig, innovativ und humanitär. Du denkst außerhalb der Norm.',
    'Pisces': 'Fische-Aszendent: Du wirkst intuitiv, mitfühlend und künstlerisch. Du bist sehr empfindsam und kreativ.'
};

function AscendantResult(props: AscendantResultProps) {
    if (!props.title) {
        return null;
    }

    const description = ascendantDescriptions[props.title] || '';

    return (
        <div className="card bg-light bg-opacity-10 border-0 mt-4 fade-in">
            <div className="card-body text-center">
                <h2 className="card-title mb-3">{props.title}</h2>
                {props.image && (
                    <div className="mb-3">
                        <img
                            src={props.image}
                            alt={props.title}
                            className="img-fluid"
                            style={{ maxHeight: '200px', objectFit: 'contain' }}
                        />
                    </div>
                )}
                {description && (
                    <p className="card-text text-start">{description}</p>
                )}
            </div>
        </div>
    );
}

export default AscendantResult;
